import { z } from "zod/mini"

// v3 SeparatorLegacy decode accepts any input and normalizes to SeparatorContent.
export const SeparatorLegacySchema = z.unknown()

export type SeparatorLegacy = z.infer<typeof SeparatorLegacySchema>
